module.exports = __webpack_public_path__ + "img/ylkt4-5.30eb9fc3.jpg";